<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div
    class="core-container column-layout"
    [class.conditional-top-padding]="topPadding"
    [class.center-align]="centerAlign"
>
    <div class="row-layout">
        <div
            dir="auto"
            class="headline font-color-primary"
            [class.font-body1]="!data?.headlineTextStyle || data.headlineTextStyle === headlineTextStyle.Body1"
            [class.font-body2]="data?.headlineTextStyle === headlineTextStyle.Body2"
            [attr.role]="data?.headline?.semanticHeadingLevel ? 'heading' : null"
            [attr.aria-level]="data?.headline?.semanticHeadingLevel || null"
            [innerHtml]="
                data?.headline.translated
                    ? data?.headline.text
                    : (data?.headline.text | translate: data?.headline.placeholders)
            "
        ></div>
        <!-- TODO -->
        <!-- Button Link -->
        <!-- <div></div> -->
    </div>
    @if (data?.supportingText?.length > 0) {
        <ul class="list-reset core-supporting-text-list">
            @for (item of data?.supportingText; track $index) {
                <li class="core-supporting-text-row font-color-tertiary">
                    @if (item.matIcon) {
                        <mat-icon class="core-supporting-icon" [svgIcon]="item.matIcon"></mat-icon>
                    }
                    <div
                        class="font-body2 font-color-tertiary"
                        [innerHtml]="item.translated ? item.text : (item.text | translate: item.placeholders)"
                    ></div>
                </li>
            }
        </ul>
    }
</div>
